module.exports = __webpack_public_path__ + "static/media/deluxe_logo_2020@2x.6a6a7292.png";